import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import EmailSenderSectionHeader from '../EmailSenderSectionHeader';
import styles from './UnconfiguredState.module.scss';
import sharedStyles from './states.module.scss';

interface UnconfiguredStateProps {
    /** Opens the wizard-root setup modal so the user can register an address. */
    onSetup: () => void;
}

/**
 * Empty state — marketplace has never configured a custom sender (or it's
 * disabled). Under the mandatory-sender rule there is no Cuddles-default
 * fallback to preview, so this state is CTA-only: header explains the
 * requirement, button starts the setup flow.
 */
const UnconfiguredState: FunctionComponent<UnconfiguredStateProps> = ({ onSetup }) => {
    return (
        <div className={sharedStyles.container}>
            <EmailSenderSectionHeader />

            <div className={styles.cta}>
                <Button
                    size="medium"
                    label="Setup Custom Sender"
                    variant="primary"
                    onClick={onSetup}
                />
            </div>
        </div>
    );
};

export default UnconfiguredState;
